import { call, takeLatest } from "redux-saga/effects";
import * as inventoryApis from "../apis/inventoryApis"
import { ADD_STOCK, ADD_STOCK_RETURN, CUSTOMERS_DROPDOWN, DELETE_INVENTORY, EDIT_INVENTORY, INVENTORY_LIST, NEW_STOCKS_LIST, NEW_STOCKS_RETURN_LIST, PRODUCTS_DROPDOWN, PURCHASED_PRODUCTS_DROPDOWN, REMOVE_STOCK, REMOVE_STOCK_RETURN, ROUTES_DROPDOWN, STOCKS_REPORT, UPDATE_INVENTORY, UPDATE_STOCK_RETURN } from "../actions/types";

/**Worker Func */
export function* inventoryListWorker(action) {
    try {
        const res = yield call(inventoryApis.inventoryListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* newStockListWorker(action) {
    try {
        const res = yield call(inventoryApis.newStockListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* addStockWorker(action) {
    try {
        const res = yield call(inventoryApis.addStockApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* removeStockWorker(action) {
    try {
        const res = yield call(inventoryApis.removeStockApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* productDropdownWorker(action) {
    try {
        const res = yield call(inventoryApis.productDropdownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* updateInventoryWorker(action) {
    try {
        const res = yield call(inventoryApis.updateInventoryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* editInventoryWorker(action) {
    try {
        const res = yield call(inventoryApis.editInventoryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* deleteInventoryWorker(action) {
    try {
        const res = yield call(inventoryApis.deleteInventoryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* stockReportWorker(action) {
    try {
        const res = yield call(inventoryApis.stockReportApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

/**Stock return */

export function* newStockReturnListWorker(action) {
    try {
        const res = yield call(inventoryApis.newStockReturnListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* addStockReturnWorker(action) {
    try {
        const res = yield call(inventoryApis.addStockReturnApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* removeStockReturnWorker(action) {
    try {
        const res = yield call(inventoryApis.removeStockReturnApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* updateInventoryStockReturnWorker(action) {
    try {
        const res = yield call(inventoryApis.updateInventoryStockReturnApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* routesDropdownWorker(action) {
    try {
        const res = yield call(inventoryApis.routesDropdownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* customersDropdownWorker(action) {
    try {
        const res = yield call(inventoryApis.customersDropdownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* purchasedProductsDropdownWorker(action) {
    try {
        const res = yield call(inventoryApis.purchasedProductsDropdownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}



/**Watcher Func */
export function* inventoryListWatcher() {
    yield takeLatest(INVENTORY_LIST, inventoryListWorker);
}
export function* newStockListWatcher() {
    yield takeLatest(NEW_STOCKS_LIST, newStockListWorker);
}
export function* addStockWatcher() {
    yield takeLatest(ADD_STOCK, addStockWorker);
}
export function* removeStockWatcher() {
    yield takeLatest(REMOVE_STOCK, removeStockWorker);
}
export function* productDropdownWatcher() {
    yield takeLatest(PRODUCTS_DROPDOWN, productDropdownWorker);
}
export function* updateInventoryWatcher() {
    yield takeLatest(UPDATE_INVENTORY, updateInventoryWorker);
}
export function* editInventoryWatcher() {
    yield takeLatest(EDIT_INVENTORY, editInventoryWorker);
}
export function* deleteInventoryWatcher() {
    yield takeLatest(DELETE_INVENTORY, deleteInventoryWorker);
}

export function* stockReportWatcher() {
    yield takeLatest(STOCKS_REPORT, stockReportWorker);
}

export function* newStockReturnListWatcher() {
    yield takeLatest(NEW_STOCKS_RETURN_LIST, newStockReturnListWorker);
}
export function* addStockReturnWatcher() {
    yield takeLatest(ADD_STOCK_RETURN, addStockReturnWorker);
}
export function* removeStockReturnWatcher() {
    yield takeLatest(REMOVE_STOCK_RETURN, removeStockReturnWorker);
}
export function* updateInventoryStockReturnWatcher() {
    yield takeLatest(UPDATE_STOCK_RETURN, updateInventoryStockReturnWorker);
}
export function* routesDropdownWatcher() {
    yield takeLatest(ROUTES_DROPDOWN, routesDropdownWorker);
}
export function* customersDropdownWatcher() {
    yield takeLatest(CUSTOMERS_DROPDOWN, customersDropdownWorker);
}
export function* purchasedProductsDropdownWatcher() {
    yield takeLatest(PURCHASED_PRODUCTS_DROPDOWN, purchasedProductsDropdownWorker);
}